import { render, staticRenderFns } from "./ParticipateHistoryView.vue?vue&type=template&id=ed35e878&scoped=true"
import script from "./ParticipateHistoryView.vue?vue&type=script&lang=js"
export * from "./ParticipateHistoryView.vue?vue&type=script&lang=js"
import style0 from "./ParticipateHistoryView.vue?vue&type=style&index=0&id=ed35e878&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed35e878",
  null
  
)

export default component.exports